function customSlideDown(element, duration = 400) {
  element.style.removeProperty("display");
  let display = window.getComputedStyle(element).display;
  if (display === "none") display = "block";
  element.style.display = display;
  let height = element.scrollHeight; // Full height of element
  element.style.overflow = "hidden";
  element.style.height = 0;
  element.offsetHeight; // Force reflow
  element.style.transitionProperty = "height";
  element.style.transitionDuration = duration + "ms";
  element.style.height = height + "px";
  window.setTimeout(() => {
    element.style.removeProperty("height");
    element.style.removeProperty("overflow");
    element.style.removeProperty("transition-property");
    element.style.removeProperty("transition-duration");
  }, duration);
}

// Custom slideUp function
function customSlideUp(element, duration = 400) {
  element.style.height = element.scrollHeight + "px"; // Set current height
  element.style.overflow = "hidden";
  element.style.opacity = "1";
  element.style.paddingTop = element.style.paddingBottom = "10px"; // Ensure smooth padding transition

  element.offsetHeight; // Force reflow

  element.style.transition = `height ${duration}ms ease, opacity ${duration}ms ease, padding ${duration}ms ease`;

  element.style.height = "0px";
  element.style.opacity = "0";
  element.style.paddingTop = element.style.paddingBottom = "0px";

  window.setTimeout(() => {
    element.style.display = "none";
    element.style.removeProperty("height");
    element.style.removeProperty("opacity");
    element.style.removeProperty("overflow");
    element.style.removeProperty("transition");
    element.style.removeProperty("padding-top");
    element.style.removeProperty("padding-bottom");
  }, duration);
}

document.addEventListener("click", function (event) {
  // Helper: Find the closest .exploded-view (for Safari & SVG)
  function getClosestHotspot(element) {
    while (element) {
      if (element.classList && element.classList.contains("exploded-view")) {
        return element;
      }
      element = element.parentNode;
    }
    return null;
  }

  // Handle accordion header clicks
  const accordionHeader = event.target.closest(".accordion-item");
  const accordionParentEle = event.target.closest(
    ".main-exploded-view-container",
  );

  if (accordionHeader && accordionParentEle) {
    const index = accordionHeader.dataset.index;
    const associatedAccordion = accordionParentEle.querySelector(
      `.accordion-item[data-index="${index}"]`,
    );
    const accordionBody = associatedAccordion.querySelector(".accordion-body");
    const accordionToggleBtn =
      associatedAccordion.querySelector(".accordion-toggle");

    if (associatedAccordion.classList.contains("open")) {
      // Close the accordion and update exploded-view active state
      customSlideUp(accordionBody, 400);
      associatedAccordion.classList.remove("open");
      associatedAccordion.classList.remove("active");
      if (accordionToggleBtn)
        accordionToggleBtn.setAttribute("aria-expanded", "false");
      accordionBody && accordionBody.setAttribute("aria-hidden", "true");
      const associatedHotspot = accordionParentEle.querySelector(
        `.exploded-view[data-index="${index}"]`,
      );
      if (associatedHotspot) {
        associatedHotspot.classList.remove("active");
      }
    } else {
      // Close other open accordion items
      accordionParentEle
        .querySelectorAll(".accordion-item.open")
        .forEach((openItem) => {
          const openBody = openItem.querySelector(".accordion-body");
          const openToggleBtn = openItem.querySelector(".accordion-toggle");
          customSlideUp(openBody, 400);
          openItem.classList.remove("open");
          openItem.classList.remove("active");
          if (openToggleBtn)
            openToggleBtn.setAttribute("aria-expanded", "false");
          openBody && openBody.setAttribute("aria-hidden", "true");
        });
      // Open this accordion item and update exploded-view active state
      customSlideDown(accordionBody, 400);
      associatedAccordion.classList.add("open");
      associatedAccordion.classList.add("active");
      if (accordionToggleBtn)
        accordionToggleBtn.setAttribute("aria-expanded", "true");
      accordionBody && accordionBody.setAttribute("aria-hidden", "false");
      const associatedHotspot = accordionParentEle.querySelector(
        `.exploded-view[data-index="${index}"]`,
      );
      if (associatedHotspot) {
        accordionParentEle
          .querySelectorAll(".exploded-view")
          .forEach((h) => h.classList.remove("active"));
        associatedHotspot.classList.add("active");
      }
    }
    return;
  }

  // Handle exploded-view clicks (with Safari fix)
  let hotspot =
    event.target.closest(".exploded-view") || getClosestHotspot(event.target);
  const hotspotParentEle = event.target.closest(
    ".main-exploded-view-container",
  );

  if (hotspot && hotspotParentEle) {
    const index = hotspot.dataset.index;
    const associatedAccordion = hotspotParentEle.querySelector(
      `.accordion-item[data-index="${index}"]`,
    );
    const accordionBody = associatedAccordion.querySelector(".accordion-body");
    const accordionToggleBtn =
      associatedAccordion.querySelector(".accordion-toggle");

    if (associatedAccordion.classList.contains("open")) {
      customSlideUp(accordionBody, 400);
      associatedAccordion.classList.remove("open");
      associatedAccordion.classList.remove("active");
      if (accordionToggleBtn)
        accordionToggleBtn.setAttribute("aria-expanded", "false");
      accordionBody && accordionBody.setAttribute("aria-hidden", "true");
      hotspot.classList.remove("active");
    } else {
      // Close any other open accordion items
      hotspotParentEle
        .querySelectorAll(".accordion-item.open")
        .forEach((openItem) => {
          const openBody = openItem.querySelector(".accordion-body");
          const openToggleBtn = openItem.querySelector(".accordion-toggle");
          customSlideUp(openBody, 400);
          openItem.classList.remove("open");
          openItem.classList.remove("active");
          if (openToggleBtn)
            openToggleBtn.setAttribute("aria-expanded", "false");
          openBody && openBody.setAttribute("aria-hidden", "true");
        });
      customSlideDown(accordionBody, 400);
      associatedAccordion.classList.add("open");
      associatedAccordion.classList.add("active");
      if (accordionToggleBtn)
        accordionToggleBtn.setAttribute("aria-expanded", "true");
      accordionBody && accordionBody.setAttribute("aria-hidden", "false");
      hotspotParentEle
        .querySelectorAll(".exploded-view")
        .forEach((h) => h.classList.remove("active"));
      hotspot.classList.add("active");
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".main-exploded-view-container")
    .forEach(function (container) {
      var firstAccordion = container.querySelector(".accordion-item");
      if (firstAccordion && !firstAccordion.classList.contains("open")) {
        firstAccordion.classList.add("open", "active");
      }
    });

  document.querySelectorAll(".exploded-view").forEach(function (hotspot) {
    hotspot.addEventListener("click", function () {});
  });
});
